"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollLoop = exports.isOverflow = void 0;
var isOverflow = function (dom) {
    return dom && dom.clientWidth < dom.scrollWidth;
};
exports.isOverflow = isOverflow;
var scroll = function (dom, callback, timeOut, durationTime) {
    if (timeOut === void 0) { timeOut = 6000; }
    if (durationTime === void 0) { durationTime = 3000; }
    var timer;
    var animation = function () {
        var left = dom.offsetLeft || 0;
        dom.style.left = "".concat(left - 1.2, "px");
        if (-left + dom.clientWidth <= dom.scrollWidth) {
            window.requestAnimationFrame(animation);
        }
        else {
            timer = setTimeout(function () {
                dom.style.left = '0px';
                if (callback) {
                    callback();
                }
                else {
                    timer = setTimeout(function () {
                        window.requestAnimationFrame(animation);
                    }, timeOut);
                }
            }, durationTime);
        }
    };
    if ((0, exports.isOverflow)(dom)) {
        timer = setTimeout(function () {
            animation();
        }, timeOut);
    }
    else {
        // 切换下一条
        if (callback) {
            timer = setTimeout(function () {
                callback();
            }, 15000);
        }
    }
    return timer;
};
var scrollLoop = function (dom, originScrollWidth, timeOut) {
    if (timeOut === void 0) { timeOut = 6000; }
    var animation2 = function () {
        var left = dom.offsetLeft || 0;
        dom.style.left = "".concat(left - 1.2, "px");
        if (-left < originScrollWidth.current + 80) {
            window.requestAnimationFrame(animation2);
        }
        else {
            dom.style.left = '0px';
            window.requestAnimationFrame(animation);
        }
    };
    var animation = function () {
        var left = dom.offsetLeft || 0;
        dom.style.left = "".concat(left - 1.2, "px");
        if (-left + dom.clientWidth <= originScrollWidth.current) {
            window.requestAnimationFrame(animation);
        }
        else {
            window.requestAnimationFrame(animation2);
        }
    };
    if ((0, exports.isOverflow)(dom)) {
        setTimeout(function () {
            animation();
        }, timeOut);
    }
};
exports.scrollLoop = scrollLoop;
exports.default = scroll;
//# sourceMappingURL=scrollAnimation.js.map